import url_ from "asset-data:assets/galleries/featured/building_343ae7720a__273.jpg";
export const url = url_;